<template>
  <div>
    <b-form-group
      class="receivers-selection"
      :label="$t('dispatching.messages.from')"
    >
      <div class="search-options">
        <SelectList
          :options="targets"
          :value="target"
          :searchable="true"
          :clearable="false"
          @select="receiverSelected"
        >
        </SelectList>
      </div>
      <div>
        <p-button
          :disabled="emptyTargets"
          @click="selectAllTargets"
          type="primary"
          >{{ $t('dispatching.messages.selectAll') }}</p-button
        >
        <p-button
          :disabled="emptyReceivers"
          @click="clearTargets"
          type="primary"
          >{{ $t('dispatching.messages.clear') }}</p-button
        >
      </div>

      <div class="receivers-list" v-if="showReceiversList">
        <b-table
          :items="receivers"
          :fields="fields"
          :sort-by="'vehicleLabel'"
          sticky-header
          tbody-class="tableClass"
          tbody-tr-class="trClass"
        >
          <template v-slot:cell(icon)="row">
            <b-icon
              class="remove"
              icon="x-circle"
              variant="dark"
              scale="1"
              @click="removeReceiver(row.index)"
            ></b-icon>
          </template>
        </b-table>
      </div>
    </b-form-group>

    <b-form-group :label="$t('dispatching.messages.message')">
      <b-form-textarea
        id="user-msg-content"
        v-model="msgText"
        :placeholder="$t('dispatching.messages.placeholder')"
      >
      </b-form-textarea>
    </b-form-group>
    <p-button
      :disabled="sendOk"
      type="success"
      @click="sendMessageFotTargets"
      >{{ $t('dispatching.messages.send') }}</p-button
    >
    <RequestInfo :ok="ok" :error="error" :loader="loading" />
  </div>
</template>

<script>
import realtime from '@/store/realtime/realtime'
import usermessage from '@/store/dispatching/usermessage.js'

export default {
  data: function () {
    return {
      target: 0,
      receivers: [],
      msgText: '',
      ok: false,
      error: false,
      loading: false,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'label',
          label: this.$t('dispatching.messages.from'),
          sortable: true,
        },
        { key: 'icon', label: '' },
      ]
    },
    targetList() {
      return this.$store.state.realtime.vehicles.list
    },
    sendOk() {
      var msgOk = this.msgText.trim().length > 0
      var receiverOk = this.receivers.length > 0
      return !(msgOk && receiverOk)
    },
    showReceiversList() {
      return this.receivers.length > 0
    },
    emptyTargets() {
      return this.targets.length === 0
    },
    emptyReceivers() {
      return this.receivers.length === 0
    },
    targets() {
      var ret = []
      // Create original list of targets
      this.targetList.forEach((item) => {
        if (item.features.VEHICLE_COMPUTER_TYPE) {
          if (
            item.features.VEHICLE_COMPUTER_TYPE != 'GPS' &&
            item.features.VEHICLE_COMPUTER_TYPE != 'Pixel'
          ) {
            var newVehicle = {}
            newVehicle.id = item.vehicleId
            newVehicle.label = item.vehicleLabel + ' : ' + item.features.NAME
            newVehicle.vehicleLabel = String(item.vehicleLabel)
            ret.push(newVehicle)
          }
        }
      })
      // Filter out selected targets
      ret = ret.filter(
        (el1) => !this.receivers.some((el2) => el1.id === el2.id)
      )
      return ret
    },
  },
  beforeCreate() {
    if (!this.$store.state.realtime) {
      this.$store.registerModule('realtime', realtime)
    }
    if (!this.$store.state.usermessage) {
      this.$store.registerModule('usermessage', usermessage)
    }
    this.$store.dispatch('realtime/getVehicles')
  },
  mounted() {
    if (this.$route.query.vehicle) {
      try {
        this.target = Number(this.$route.query.vehicle)
      } catch (err) {
        // something
      }
      document.getElementById('user-msg-content').focus()
    } // TODO add handling of vehicleLabel
  },
  methods: {
    clearTargets() {
      this.receivers.splice(0, this.receivers.length)
      this.target = ''
    },
    receiverSelected(value) {
      let selected = this.targets.find((item) => {
        return item.id == value
      })
      this.target = selected.label

      if (!this.receivers.includes(selected)) this.receivers.push(selected)
    },
    removeReceiver(index) {
      this.receivers.splice(index, 1)
      this.target = ''
    },
    selectAllTargets() {
      this.targets.forEach((it) => {
        this.receivers.push(it)
      })
    },
    sendMessageFotTargets() {
      this.receivers.forEach((receiver) => {
        this.sendMsg(receiver.id)
      })
      this.receivers = []
      this.msgText = ''
    },
    sendMsg(target) {
      var msg = {
        message: this.msgText,
        sender: 'admin',
        vehicleId: target,
      }
      const self = this
      this.ok = this.error = false
      this.loading = true
      this.$store
        .dispatch('usermessage/sendVehicleMessage', msg)
        .then(() => {
          setTimeout(() => {
            self.ok = true
            self.loading = false
          }, 1000)
        })
        .catch(() => {
          setTimeout(() => {
            self.error = true
            self.loading = false
          }, 1000)
        })
    },
    translateDestType(value) {
      var int18Str = `user_messages.destination_type.${value}`
      return this.$t(int18Str)
    },
  },
}
</script>

<style lang="scss">
.tableClass tr.trClass td {
  padding: 2px 5px;
}
</style>

<style scoped lang="scss">
div.search-input {
  width: 200px;
  float: left;
}

div.search-options {
  max-width: 400px;
  margin-right: 10px;
}

div.receivers-selection {
  display: flex;
  flex-direction: column;
}

div.receivers-list {
  border: 1px solid #ccc;
  padding: 3px;
  border-radius: 4px;
}
</style>
